/* =========================================
   BRITEN: Unified Tracking + A/B Tests + Add to Cart + Mobile Sticky ATC
   Meta events come only from the Shopify Facebook & Instagram app pixel
   (browser + Conversions API, deduplicated). Nothing here calls fbq:
   internal events (A/B impressions, quiz, sticky ATC) stay in PostHog/GA4.

   Add to Cart: every product form (PDP, sticky bar, collection quick add)
   goes through britenAddToCart. The legacy cart drawer has no script in
   this theme, so Dawn's product-form handler throws before adding; this
   handler adds via /cart/add.js (plus the refill add-on when chosen) and
   lands on /cart, where the free-shipping bar lives.
   ========================================= */

// -- Unified event helper --
function britenTrack(name, props) {
  props = props || {};
  if (typeof gtag === 'function') gtag('event', name, props);
  if (typeof posthog !== 'undefined' && posthog.capture) posthog.capture(name, props);
}

// -- A/B Testing Engine --
var britenTests = {
  hero_headline: {
    variants: ['control'], // dentist_led paused for launch so the H1 is stable for Google
    apply: function(variant) {
      var el = document.querySelector('.bh-hero h1');
      if (!el) return;
      if (variant === 'dentist_led') {
        el.innerHTML = 'Dentist-formulated.<br>Sensitivity-free.<br><strong>Proven.</strong>';
      }
    }
  },
  hero_cta: {
    variants: ['control'], // shop_now paused for launch
    apply: function(variant) {
      var el = document.querySelector('.bh-hero .bh-btn-white');
      if (!el) return;
      if (variant === 'shop_now') el.textContent = 'Shop Now';
    }
  }
};

function britenGetCookie(n) {
  var m = document.cookie.match(new RegExp('(?:^|; )' + n + '=([^;]*)'));
  return m ? m[1] : null;
}
function britenSetCookie(n, v, days) {
  var d = new Date();
  d.setTime(d.getTime() + (days * 86400000));
  document.cookie = n + '=' + v + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
}

function britenRunABTests() {
  for (var testName in britenTests) {
    var test = britenTests[testName];
    var cookieKey = 'briten_ab_' + testName;
    var variant = britenGetCookie(cookieKey);
    if (!variant) {
      variant = test.variants[Math.floor(Math.random() * test.variants.length)];
      britenSetCookie(cookieKey, variant, 30);
    }
    test.apply(variant);
    britenTrack('ab_impression', { test: testName, variant: variant });
  }
}

// -- Refill add-on state (snippets/briten-refill-addon.liquid) --
function britenAddonItem() {
  var box = document.querySelector('[data-briten-addon]');
  if (!box) return null;
  var check = box.querySelector('.bra-check');
  if (!check || !check.checked) return null;
  var item = { id: parseInt(box.getAttribute('data-variant'), 10), quantity: 1 };
  var plan = box.querySelector('input[name="bra-plan"]:checked');
  if (plan && plan.value && plan.value !== 'once') item.selling_plan = parseInt(plan.value, 10);
  return item;
}

function britenSetBusy(form, busy) {
  var btn = form.querySelector('[type="submit"], [name="add"]');
  if (!btn) return;
  btn.classList.toggle('loading', busy);
  btn.setAttribute('aria-disabled', busy ? 'true' : 'false');
}

function britenShowError(form, msg) {
  var wrap = form.closest('product-info, .product__info-container, .card, section') || form.parentNode;
  var box = wrap.querySelector('.briten-atc-error');
  if (!box) {
    box = document.createElement('p');
    box.className = 'briten-atc-error';
    box.setAttribute('role', 'alert');
    form.parentNode.insertBefore(box, form.nextSibling);
  }
  box.textContent = msg;
}

function britenAddToCart(form) {
  var fd = new FormData(form);
  var id = parseInt(fd.get('id'), 10);
  if (!id) return false;
  var qty = parseInt(fd.get('quantity') || '1', 10) || 1;
  var main = { id: id, quantity: qty };
  var plan = fd.get('selling_plan');
  if (plan) main.selling_plan = parseInt(plan, 10);
  var items = [main];
  var isMainForm = !!form.closest('.product__info-container, product-info');
  var addon = isMainForm ? britenAddonItem() : null;
  if (addon) items.push(addon);

  britenSetBusy(form, true);
  var title = document.querySelector('.product__title h1, .product__title');
  britenTrack('add_to_cart', {
    product: title ? title.textContent.trim() : 'unknown',
    refill_addon: addon ? (addon.selling_plan ? 'autoship' : 'one_time') : 'none'
  });

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ items: items })
  }).then(function(r) {
    return r.json().then(function(data) { return { ok: r.ok, data: data }; });
  }).then(function(res) {
    if (res.ok) {
      window.location.href = '/cart';
    } else {
      britenSetBusy(form, false);
      britenShowError(form, (res.data && (res.data.description || res.data.message)) || 'Something went wrong. Please try again.');
    }
  }).catch(function() {
    britenSetBusy(form, false);
    britenShowError(form, 'Something went wrong. Please try again.');
  });
  return true;
}

// Capture phase: runs before Dawn's product-form listener on the form.
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;
  e.preventDefault();
  e.stopImmediatePropagation();
  britenAddToCart(form);
}, true);

// -- Mobile sticky Add to Cart bar (product pages) --
function britenStickyATC() {
  // Find the button first: the buy box also holds Dawn's installments form, which has no button.
  var realBtn = document.querySelector('.product__info-container form[action*="/cart/add"] .product-form__submit') || document.querySelector('form[action*="/cart/add"] [name="add"]');
  var form = realBtn ? (realBtn.form || realBtn.closest('form')) : null;
  if (!form || !realBtn || document.querySelector('.briten-sticky-atc')) return;
  var priceEl = document.querySelector('.product__info-container .price-item--sale, .product__info-container .price-item--regular');
  var price = priceEl ? priceEl.textContent.trim() : '';

  var bar = document.createElement('div');
  bar.className = 'briten-sticky-atc';
  bar.innerHTML = '<span class="satc-price">' + price + '</span>' +
                  '<button type="button" class="satc-btn">Add to Cart</button>';
  document.body.appendChild(bar);
  document.body.classList.add('briten-has-sticky-atc');

  bar.querySelector('.satc-btn').addEventListener('click', function() {
    britenTrack('sticky_atc_click');
    if (form.requestSubmit) { form.requestSubmit(realBtn); } else { britenAddToCart(form); }
  });

  // show only after the real button scrolls out of view
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function(entries) {
      bar.classList.toggle('active', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(realBtn);
  } else {
    bar.classList.add('active');
  }
}

// -- Refill add-on: reveal plan choice when checked --
document.addEventListener('change', function(e) {
  var check = e.target.closest ? e.target.closest('.bra-check') : null;
  if (!check) return;
  var box = check.closest('[data-briten-addon]');
  if (box) box.classList.toggle('is-on', check.checked);
  britenTrack('refill_addon_toggle', { on: check.checked });
});

// -- Quiz open tracking --
document.addEventListener('click', function(e) {
  if (e.target.closest('[data-quiz-trigger]')) britenTrack('quiz_open');
});

// -- Boot --
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() { britenRunABTests(); britenStickyATC(); });
} else {
  britenRunABTests();
  britenStickyATC();
}
